import React,{useContext, useEffect, useState} from "react";
import Modal from "components/global/modal";
import ModalHeader from "components/global/modal-header";
import { SubscriptionContext } from "context/subscription";
import LinkGroupSelect from "components/link-group/LinkGroupSelect";
import { useTranslation } from "react-i18next";
import LockOutlineIcon from "assets/svg/upgrade/lock-outline-icon";
import UpgradePremium from "components/subscription/upgrade-premium";
import { maxUploadSize,mediaTypes_init, mediaSubTypes_init} from "utils/constant";
import { useMediaSubTypes } from "redux/modules/media-sub-type/hooks";
import _ from "lodash";
import { useDialogHook } from "utils/customhooks";
import update from "immutability-helper";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import Button from "components/button/button";
import toast from "react-hot-toast";
import { useMilestones } from "redux/modules/milestone/hooks";

const MediaButtonEdit = ({
   hide,
  mediaTypes,
  userData,
  linkTypeList,
  buttonCount,
  ...props
}) => { 
  const { isSubscribed } = useContext(SubscriptionContext);
  const { http } = global.services;
  const {t} = useTranslation();
  const maxSelectedImages = 50;
  const {
      refresh: refreshMediaSubTypes,
      initialize: initializeMediaSubTypes,
      types: mediaSubTypes,
      setMediaSubTypes,
    } = useMediaSubTypes();

  const [mediaTypeOptions, setMediaTypeOptions] = useState(mediaTypes);
  const [linkType, setLinkType] = useState(linkTypeList);
  const [removelinkType, setRemoveLinkType] = useState([]);
  const [errorMessages, setErrorMessages] = useState({});
  const uploadSizeModal = useDialogHook(UploadSizeModal);
  const [buttonCountState, setButtonCountState] = useState(buttonCount);
  const { setButtonCount } = useMilestones();
  
  const onAddTypeLink = (type) => {
      let newLinkType = null;

      if (type === "Link") {
        newLinkType = { type: 1, subType: "Link", value: "", label: "Website" };
      }
      else if (type === "Video Embed") {
        newLinkType = { type: 1, subType: "Video Embed", value: "", label: "Watch", orientation :"Landscape"};
      }
      else if (type === "Video File") {
        newLinkType = { type: 1, subType: "Upload", value: "", label: "Watch" };
      }
      else if (type === "Audio File") {
        newLinkType = { type: 1, subType: "Audio File", value: "", label: "Listen" };
      }
      else if (type === "Images") {
        newLinkType = { type: 1, subType: "Multiple Images", value: [], label: "Images" };
      }
      else if (type === "Read") {
        newLinkType = { type: 1, subType: "Upload", value: "", label: "Read" };
      }

      newLinkType.order = linkType.length;
        

      let payload = _.clone(linkType);
      payload.push(newLinkType);
      setLinkType(payload);
      setButtonCountState(buttonCountState + 1);
    };

    const onUploadMultipleLink = async (e, index) => {
    let fileSize = 0;
    let payload = _.clone(linkType);
    let currValue = linkType[index].value ?? {};
    e.forEach((f) => {
      fileSize += parseFloat(f.size);
    });

    if (Array.isArray(currValue)) {
      currValue.forEach((cv) => {
        if (cv.media) {
          fileSize += parseFloat(cv.media.file_size || 0);
        } else {
          fileSize += cv.size || 0;
        }
      });
    } 
    if (fileSize < maxUploadSize) {
      let result = update(payload, {
        [index]: {
          value: { $set: [...currValue, ...e] },
        },
      }); 
      setLinkType(result);
    } else {
      setErrorMessages({
        ...errorMessages,
        [`media.${index}.value`]: "The file is too large. Maximum size is 50MB.",
      });
      showUploadAlert();
    }
  };

  const showUploadAlert = () => {
    uploadSizeModal({}, (callback) => {
      console.log("callback", callback);
    });
  };

  const onUploadLink = async (e, index) => {
      let payload = _.clone(linkType);
      let result = update(payload, {
        [index]: {
          value: { $set: e },
        },
      }); //remove
      setLinkType(result);
    };

  const onTypeLink = (e, index) => {
      let payload = _.clone(linkType);
      let result = update(payload, {
        [index]: {
          value: { $set: e.target.value },
        },
      }); //remove
      setLinkType(result);
    };
  
    const onBlurTypeLink = (index) => {
      let payload = _.clone(linkType);
      let value = payload[index].value;
  
      if (payload[index].subType === "Link" || payload[index].subType.label === "Link") {
        if (value && !value.includes("http://") && !value.includes("https://")) {
          value = `https://${value}`;
        }
  
        let result = update(payload, {
          [index]: {
            value: { $set: value },
          },
        }); //remove
        setLinkType(result);
      }
    };

    const onSelectTypeLink = (e, index) => {
        let payload = _.clone(linkType);
        let result = update(payload, {
          [index]: {
            type: { $set: e.value },
          },
        }); //remove
        setLinkType(result);
      };

    const onRemoveTypeLink = (index) => {
        let payload = _.clone(linkType);
        let removedPayload = _.clone(removelinkType);
        removedPayload.push(payload[index]);
        setRemoveLinkType(removedPayload);
    
        let result = update(payload, { $splice: [[index, 1]] }); //remove
    
        setLinkType(result);
        setButtonCountState(buttonCountState - 1);
      };

    const onSelectSubTypeLink = (e, index) => {
        let payload = _.clone(linkType);
        let params = {
          subType: { $set: e },
          value: { $set: "" },
        };
        if (payload.placeholder) {
          params.placeholder = { $set: "" };
        }
        let result = update(payload, {
          [index]: params,
        }); //remove
        setLinkType(result);
      };
    
      const onRemoveMediaLink = (e, index) => {
        let payload = _.clone(linkType);
        let results = linkType[index]["value"].filter((f, i) => i !== e);
        payload[index]["value"] = results.length > 0 ? results : "";
    
        // check if errorMessages has multiple_images and remove this error if results.length <= 10
        if (errorMessages?.multiple_images && results.length <= 10) {
          delete errorMessages.multiple_images;
        }
    
        setLinkType(payload);
        setErrorMessages({ ...errorMessages });
      };

    const onLabel = async (e, index) => {
      let payload = _.clone(linkType);
      let result = update(payload, {
        [index]: {
          label: { $set: e.target.value },
        },
      }); 
      setLinkType(result);
    }
    const facebookOrient = async (e, index) => {
        let payload = _.clone(linkType);
        let result = update(payload, {
          [index]: {
            orientation: { $set: e.value },
          },
        }); 
        console.log(result)
        setLinkType(result);
      }

  const updateButtonCount = async () => {
    const { data } = await http.get("public/milestones/media-types/count");
    setButtonCount(data?.count ?? 0);
  };
    
    const submit = ()=>{
      let errors = {}
      let errorOccured = false;
      linkType.forEach(async (media, index) => {
        let mediaData = _.clone(media);
        if (mediaData.subType === "Multiple Images") {
          mediaData.type = mediaTypes_init.find((mt) => mt.label === "Images").value;
          mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Multiple Images").value;
          mediaData.is_media = true;
          for(let i = 0; i < mediaData.value.length; i++){
            if(mediaData.value[i].progress){
              errors = {
                ...errors,
                "images": ["Please wait until the image is uploaded.."],
              };
              errorOccured = true;
              return toast.error(t('Please wait until the image is uploaded..'));
            }
          }
        }
        else if (mediaData.subType === "Audio File") {
        mediaData.type = mediaTypes_init.find((mt) => mt.label === "Listen").value;
        mediaData.subTypeId = mediaSubTypes_init.find((ms) => ms.label === "Audio File").value;
        mediaData.is_media = true;
        if(typeof mediaData.value === "string" || mediaData.value instanceof File){
            errors = {
              ...errors,
              "images": ["Please wait until the audio is uploaded.."],
            };
             toast.error(t('Please wait until the audio is uploaded..'));
             errorOccured = true;
          }
      }

      });
      if(errorOccured) return;
      updateButtonCount();
      hide({
        success:true,
        linkType,
        removelinkType
      });
    }
    return (
      <div className="smooth-dnd-parent">
        <Modal
              width="w-full md:w-16/20 2md:w-12/20 3md:w-9/20 1xl:w-8/20"
              contentClassName="rounded-lg overflow-auto custom-scroll"
              wrapperClassName="overflow-visible" 
          >
            <div className="w-full relative px-6 pt-4">
              <ModalHeader
                  title={t("editMedia")}
                  hide={hide}
                  showPopInfo
                  popInfoType="add_milestone"
                  padding = "pl-4 pr-7 py-3.5"
                  />

                <div className="max-h-[70dvh] overflow-y-scroll px-0 md:px-4">
                  {/** media buttons */}
                      <LinkGroupSelect
                        options={mediaTypeOptions}
                        subOptions={mediaSubTypes}
                        label={t('addImagePDF')}
                        optional={true}
                        isSubscribed={isSubscribed}
                        linkType={linkType}
                        currentButtonCount={buttonCountState}
                        userData={userData}
                        setItems={setLinkType}
                        onAdd={onAddTypeLink}
                        onUploadMultiple={(e, index) => onUploadMultipleLink(e, index)}
                        onUpload={(e, index) => onUploadLink(e, index)}
                        onChange={(e, index) => onTypeLink(e, index)}
                        onSelect={(e, index) => onSelectTypeLink(e, index)}
                        onBlur={(index) => onBlurTypeLink(index)}
                        onRemove={(index) => onRemoveTypeLink(index)}
                        onSelectSubType={(e, index) => onSelectSubTypeLink(e, index)}
                        onRemoveMedia={(e, index) => onRemoveMediaLink(e, index)}
                        onChangeLabel={(e, index) => onLabel(e, index)}
                        facebookOrient ={(e, index) => facebookOrient(e, index)}
                        errors={errorMessages}
                        maxSelectedImages={maxSelectedImages}
                      />
                </div>
                <div className="border-t border-gray py-4 px-4">
                  <div className="w-full flex items-center justify-end 1sm:justify-end space-x-2">
                      <Button
                          buttonName={t('cancel')}
                          buttonClass="bg-thBg py-4 px-8 hover:bg-gray min-w-[7rem]"
                          buttonTextClass="text-black text-sm font-semibold"
                          onClick={() => hide()}
                          // disabled={submitLoading}
                      />
                      <Button
                          key="save-btn-category"
                          buttonName={t('save')}
                          buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary min-w-[7rem]"
                          buttonTextClass="w-full text-white text-sm font-semibold flex items-center justify-center"
                          onClick={submit}
                      />
                  </div>
              </div> 
            </div>
        </Modal>
      </div>
    )
};

export default MediaButtonEdit;
